/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Read_Along_Exit_FullscreenInputs */

const en_read_along_exit_fullscreen = /** @type {(inputs: Read_Along_Exit_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exit fullscreen`)
};

const es_read_along_exit_fullscreen = /** @type {(inputs: Read_Along_Exit_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salir de pantalla completa`)
};

/**
* | output |
* | --- |
* | "Exit fullscreen" |
*
* @param {Read_Along_Exit_FullscreenInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_exit_fullscreen = /** @type {((inputs?: Read_Along_Exit_FullscreenInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_Exit_FullscreenInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_exit_fullscreen(inputs)
	return en_read_along_exit_fullscreen(inputs)
});